import client from './client';

export const getGames = async (params = {}) => {
  const response = await client.get('/api/games', { params });
  return response.data;
};

export const getGame = async (id) => {
  const response = await client.get(`/api/games/${id}`);
  return response.data;
};

export const createGame = async (gameData) => {
  const response = await client.post('/api/games', gameData);
  return response.data;
};

export const updateGame = async (id, gameData) => {
  const response = await client.put(`/api/games/${id}`, gameData);
  return response.data;
};

export const deleteGame = async (id) => {
  const response = await client.delete(`/api/games/${id}`);
  return response.data;
};

export const joinGame = async (id, inviteCode) => {
  const response = await client.post(`/api/games/${id}/join`, { inviteCode });
  return response.data;
};

export const joinGameByCode = async (inviteCode) => {
  const response = await client.post('/api/games/join', { inviteCode });
  return response.data;
};

export const leaveGame = async (id) => {
  const response = await client.post(`/api/games/${id}/leave`);
  return response.data;
};

/**
 * Get combined game state in a single request
 * Reduces multiple API calls to one for the Game page
 */
export const getGameState = async (id) => {
  const response = await client.get(`/api/games/${id}/state`);
  return response.data;
};
